import { useMemo } from 'react';
import { useGetList } from 'react-admin';
import { AVATAR_TRACEABILITY_NOTES } from '../../providers/resources';
import { extractIdFromURI } from '../../utils/resources/ids';

/** The history of an installation, most recent first: the same notes as the history panel. */
const useInstallationNotes = (avatarId?: string | null) => {
    const id = avatarId ? extractIdFromURI(avatarId) : null;

    const { data, ids, loading, error }: any = useGetList(
        AVATAR_TRACEABILITY_NOTES,
        { page: 1, perPage: 100 },
        { field: 'createdAt', order: 'DESC' },
        { avatarId: id },
        { enabled: !!id },
    );

    const notes: any[] = useMemo(() => (ids || []).map((noteId: any) => data?.[noteId]).filter(Boolean), [ids, data]);

    return { notes, loading, error };
};

export default useInstallationNotes;
